import { Settings } from "../settings";

export type TAdditionalData = {
    status: "planned"|"started"|"live",
    year: string,
    done: number,
    brand: string,
    languages: string[],
    features: string[],
    type: "3D"|"System"|"Selection"
}

export type TSettings = {
    type: string,
    start: string,
    orgID: string,
    language: string,
    noTest?: boolean
}

export type TConfigurator = {
    extern: boolean,
    hidden: boolean,
    configuratorName: TTranslatedText[]|string,
    url: TTranslatedText[]|string,
    shortText?: TTranslatedText[]|string,
    pictureUrl?: string,
    additionalData?: TAdditionalData,
    settings: TSettings
}

export type TTranslatedText = {
    default:boolean,
    language:string,
    text:string
}

export type TMarket = {
    orgId: string
    description: TTranslatedText[]|string,
    list?: TConfigurator[]
}

export type TConfiguratorList = TMarket[]

export class Rest {
    static async getConfiguratorList():Promise<TConfiguratorList>{
        return (await Settings.dataConnection.get("")).data
    }

    static getTranslatedText(description:TTranslatedText[]|string|undefined):string{
        if (typeof description === "string"){
            return description
        }

        if (description === undefined){
            return ""
        }
        const language = navigator.language;
        const languageParts = language.split("-")

        for(var element of description){
            for(var languageKey of languageParts){
                if(languageKey.toLocaleLowerCase() === element.language.toLocaleLowerCase()){
                    return element.text;
                }
            }
        }

        var returnValue = ""
        for(element of description){
            if(element.default){
                return element.text
            }

            if(element.language.toLocaleLowerCase() === "en"){
                returnValue = element.text;
            }

            if (returnValue === ""){
                returnValue = element.text;
            }
        }

        return returnValue;
    }
}